import { createContext } from 'react';

import { PromptOptions, PromptResultStatus } from './types';

export const PromptContext = createContext<
  (promptOptions: PromptOptions) => Promise<PromptResultStatus>
>(() => Promise.resolve('close'));
